import sortByAttribute from './sortByAttribute';

export const helpers = {
  sortByAttribute,
};
